import request from '@/router/axios'

const BASE = '/api/produce/meter-energy-record'

export function fetchPage(data) {
  return request({ url: `${BASE}/select/page`, method: 'post', data: data || {} })
}

export function fetchById(id) {
  return request({ url: `${BASE}/select/id`, method: 'get', params: { id } })
}

export function insertRecord(data) {
  return request({ url: `${BASE}/insert`, method: 'post', data })
}

export function updateRecord(data) {
  return request({ url: `${BASE}/update`, method: 'post', data })
}

export function deleteRecord(id) {
  return request({ url: `${BASE}/delete/id`, method: 'get', params: { id } })
}

export function exportExcel(data) {
  return request({
    url: `${BASE}/export`,
    method: 'post',
    data: data || {},
    responseType: 'blob'
  })
}
